module.exports = __webpack_public_path__ + "img/layer2.619974e2.png";